import $ from "jquery";
import { addAbout } from './addAbout';
import { addEducation } from './addEducation';
import { rotateGraphs } from './rotateGraphs';
import { addSkills } from './addSkills';
import { addProfessionalExperience } from './addProfessionalExperience';
import { setButtonStatus } from './setButtonStatus';

$(() => {
	let activeProfessionalExperience = 0;

	$.getJSON('cv.json', data => {
		console.log('200 OK: data recived');
		
		rotateGraphs();
		addSkills(data.skills);
		addProfessionalExperience(data.professionalExperience);
		addEducation(data.education);
		addAbout(data.about);

		const experienceLenght = data.professionalExperience.length;

		$('#professionalExperience > h2').append(` (${experienceLenght})`);
		setTimeout(() => {
			// niepotrzebna spacja w `fadeIn( '.2s'`
			$(`#pe${activeProfessionalExperience}`).fadeIn( '.2s');
		});

		$('#professionalExperience .prev').click(() => {
			$('#professionalExperience .prev').removeClass('enebled').addClass('disabled');
			if(activeProfessionalExperience > 0) {
				$(`#pe${activeProfessionalExperience}`).fadeOut('.2s', () => {
					activeProfessionalExperience--;
					$(`#pe${activeProfessionalExperience}`).fadeIn('.2s');
					$('#professionalExperience .prev').removeClass('disabled').addClass('enebled');
					setButtonStatus(experienceLenght, activeProfessionalExperience);
				});
			}
		});

		$('#professionalExperience .next').click(() => {
			$('#professionalExperience .next').removeClass('enebled').addClass('disabled');
			if(activeProfessionalExperience < experienceLenght-1){
				$(`#pe${activeProfessionalExperience}`).fadeOut('.2s', () => {
					activeProfessionalExperience++;
					$(`#pe${activeProfessionalExperience}`).fadeIn('.2s')
					$('#professionalExperience .next').removeClass('disabled').addClass('enebled');
					setButtonStatus(experienceLenght, activeProfessionalExperience);
				});
			}
		});

		$('#professionalExperience .show').click(() => {
			// niepotrzebna spacja w `( 'slow'`
			$('.professionalExperienceBox').fadeIn( 'slow', () => {
				$('#professionalExperience .next').toggle();
				$('#professionalExperience .prev').toggle();
				$('#professionalExperience .show').toggle();
				$('#professionalExperience .hide').toggle();
				activeProfessionalExperience = 0;
			});
		});

		$('#professionalExperience .hide').click(() => {
			$('.professionalExperienceBox').fadeOut('slow', () => {
				$(`#pe${activeProfessionalExperience}`).fadeIn('slow');
				setButtonStatus(experienceLenght, activeProfessionalExperience);
				$('#professionalExperience .next').fadeIn('slow');
				$('#professionalExperience .prev').fadeIn('slow');
				$('#professionalExperience .show').fadeIn('slow');
				$('#professionalExperience .hide').toggle();
			});
		});
		
	}).fail((jqxhr, textStatus, error) => {
		console.log(`Request Failed: ${textStatus} , ${error}`);
		$('body > *').hide();
		$('body').append(`
			<div class="alert">
				Request Failed: JSON is not correct or unredable!
			</div>
		`);
		});
});
